import { map } from 'rxjs/operators';
import { mapConnections } from './connection';

export let CIRCLE_NAMES = {
  inner: "Inner Circle",
  close: "Close Circle",
  casual: "Casual Circle"
}


export interface Person {
  documentId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  dob?: Date;
  phone?: string;
  picture?: string;
  gender?: string;
  connections?: any[];
  description?: string;
  notes?: any[];
  circle?: string;
  circleName?: string;
  contactPeriod?: string;
  lastOnline?: Date;
  user?: string;
}

export function mapPeople(people, v5=false): Person[] {
  let list;
  if (v5)  list = people?.map(person => mapEntity(person))
  else  list = people?.data?.map(person => mapEntity(person))
  return list;
}

export function mapPerson(person): Person {

  if (person?.data) return mapEntity(person?.data)
  else mapEntity(person)
}

export function mapEntity(person): Person {

  let obj;

  if (person.attributes) obj = person.attributes ;
  else obj = person;

  obj.documentId = person.documentId;

  obj.circleName = CIRCLE_NAMES[obj?.circle];
  obj.name = `${obj.firstName} ${obj.lastName}`;
  if (obj?.contactPeriod == "bi_weekly") obj.contactPeriod = 'bi-weekly';
  obj.picture = obj?.picture?.data?.attributes?.formats?.small?.url ?? obj?.picture?.data?.attributes?.url ?? obj?.picture?.formats?.small?.url ?? obj?.picture?.url;

  obj.connections = mapConnections(obj?.connections)
  return obj;
}

